import React from 'react'
import {Link} from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image';

import * as allRecipesStyles from '../pages/vegan-life/allRecipes.module.scss'

const RecipeList = ({ data}) => {
    return(<div>
        <ul className={allRecipesStyles.list}>
                  { 
                  data.map((edge) => {
                      return (
                      <li key={edge.node.slug} className={allRecipesStyles.singleBlock}>
                        <Link to={`/vegan-life/${edge.node.slug}`}>
                          <GatsbyImage image={edge.node.thumbnailImage.imgixImage.gatsbyImageData} alt={edge.node.thumbnailImage.title} />
                          <p className={allRecipesStyles.singleBlockTitle}>{edge.node.blogTitle}</p>
                        </Link>
                      </li>
                      )
                  })}
                  </ul>
                  
    </div>)
}

export default RecipeList